import Replacement41_4Header from "./Header";
import "./index.css";
import { useState } from "react";
import InputsFromReplacement41_4a from "../ProdUseStage41/InputsFromReplacement41_4a";
import SurplusResourcesReplacement41_4b from "../ProdUseStage41/SurplusResourcesReplacement41_4b";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdReplacement41_4Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const [totalProdItem, setTotalProdItem] = useState([]);

  return (
    <div className="prod-replacement-41-4-container" id="prod-replacement-41-4-id">
      <Replacement41_4Header
        productId={productId}
        show={show}
        totalProdItem={totalProdItem}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <InputsFromReplacement41_4a productId={productId} />
          <SurplusResourcesReplacement41_4b productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdReplacement41_4Components;

